module.exports = __webpack_public_path__ + "img/icon_cowcalving_colour.23973adb.svg";